import AOS from "aos";
import "aos/dist/aos.css";
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { TiSocialFacebook } from "react-icons/ti";
import { Link } from "react-router-dom";
import "../css/contact.scss";

const Contact = ({ data }) => {

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className='footer-container' id='contact'>
      <div className="logo-container">
        <div className="title-logo">
          <img alt='logo' className='logo' src="/images/logo.png" height={64} width={64} />
          <div className="logo-title">{data.title}</div>
        </div>
      </div>
      <div className='footer-inner'>
        <section className='address-container'>
          <div className='address-title'>{data.address}</div>
          <div className='location'>{data.location}</div>
        </section>

        <section className='contact-container'>
          <div className='contact-title'>{data.contactUs}</div>
          <div className='contact-row'>
            {data.mail}: {data.mailAddress}
          </div>
          <div className='contact-row'>
            {data.phone}: {data.phoneNum}
          </div>
          <div className='contact-row'>
            {data.workhours}
          </div>
          <div className="social-row">
            <a
              href={data.facebookAddress}
              target='blank'
              className='facebook'>
              <TiSocialFacebook color="black" size={20}/>
            </a>
          </div>
        </section>

        <section className='links-container'>
          <div className='links-title'>{data.link}</div>
          {data.links.map((link, index) => (
            <div key={index} className='link-row'>
              <Link to={link.link} rel="noopener noreferrer">
                {link.name}
              </Link>
            </div>
          ))}
        </section>
      </div>
      <div className="copyright">
        <p>© {new Date().getFullYear()} {data.copyright}</p>
      </div>
    </div>
  );
};

Contact.propTypes = {
  data: PropTypes.shape({
    location: PropTypes.string.isRequired,
    mail: PropTypes.string.isRequired,
    phoneNum: PropTypes.string.isRequired,
    facebookAddress: PropTypes.string.isRequired,
  }).isRequired,
};
export default Contact;
